import React from "react";
import poweredby from "../../assets/img/poweredby.svg";
import mada from "../../assets/img/mada_logo.svg";
import visa from "../../assets/img/visa_logo.svg";
import mastercard from "../../assets/img/mastercard_logo.svg";
import sabb from "../../assets/img/sabb.svg";
import Storage from "../../services/storage.service";

const CommonPaymentLogo = props => {
	let business = Storage.get("business", true);
	if (business) {
		business = JSON.parse(business);
	}
	return (
		<div className="common-payment-logo">
			{!business?.enable_tap_payment ? <div className="poweredby">
				<img src={poweredby} alt="" />
			</div> : null}

			{business?.show_mada_cc_icon ?
			<div>
				<img src={mada} alt="" />
			</div> : null}

			<div>
				<img src={visa} alt="" />
			</div>

			<div>
				<img src={mastercard} alt="" />
			</div>
			
			{business?.show_sabb_cc_icon ? <div>
				<img src={sabb} alt="" />
			</div>
				: null}
		</div>
	);
};
export default CommonPaymentLogo;
